import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject,
  createHttpLink,
  from,
} from '@apollo/client';
import { Headers, fetch } from 'cross-fetch';

import { isServer } from 'src/shared/helpers/environment';

import { auth } from './link';

interface ClientOptions {
  cookie?: string;
  state?: string;
  uri: string;
}

if (isServer()) {
  global.Headers = Headers;
}

// FIXME: use singleton pattern to avoid this mutable export?
// eslint-disable-next-line import/no-mutable-exports
let client: ApolloClient<NormalizedCacheObject>;

const createClient = ({ cookie, state, uri }: ClientOptions) => {
  const http = createHttpLink({
    uri,
    credentials: 'include',
    fetch,
    headers: cookie ? { cookie } : {},
  });

  const link = isServer() ? http : from([auth, http]);
  const cache = state
    ? new InMemoryCache().restore(JSON.parse(state))
    : new InMemoryCache();

  client = new ApolloClient({ cache, link, ssrMode: isServer() });

  return client;
};

export { client, createClient };
